import React from "react";
import { X, Filter, Search } from "lucide-react";

const FilterDrawer = ({
  isOpen,
  onClose,

  // Search
  showSearch = false,
  searchTerm = "",
  onSearchChange,

  // User Filter
  showUserFilter = false,
  users = [],
  selectedUser = "",
  onUserChange,

  // Date Filter
  showDateFilter = false,
  filterType = "month",
  onFilterTypeChange,

  dateRange = {
    from: "",
    to: "",
  },
  onDateRangeChange,

  // Actions
  onReset,
  onApply,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 top-16 bg-black/40 z-40"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="fixed top-16 right-0 h-full w-full sm:w-[420px] bg-white shadow-xl z-50 overflow-y-auto">

        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b sticky top-0 bg-white">
          <div className="flex items-center gap-2">
            <Filter size={18} />
            <h2 className="text-lg font-semibold">
              Filters
            </h2>
          </div>

          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-5">

          {/* Search */}
          {showSearch && (
            <div>
              <label className="block text-sm font-medium mb-2">
                Search
              </label>

              <div className="relative">
                <Search
                  size={16}
                  className="absolute left-3 top-3 text-gray-400"
                />

                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) =>
                    onSearchChange?.(e.target.value)
                  }
                  placeholder="Search..."
                  className="w-full pl-10 pr-4 py-2 border rounded-lg"
                />
              </div>
            </div>
          )}

          {/* User Filter */}
          {showUserFilter && (
            <div>
              <label className="block text-sm font-medium mb-2">
                User
              </label>

              <select
                value={selectedUser}
                onChange={(e) =>
                  onUserChange?.(e.target.value)
                }
                className="w-full border rounded-lg px-3 py-2"
              >
                <option value="">
                  All Users
                </option>

                {users.map((user) => (
                  <option
                    key={user._id}
                    value={user._id}
                  >
                    {user.firstName} {user.lastName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Date Filter */}
          {showDateFilter && (
            <>
              <div>
                <label className="block text-sm font-medium mb-2">
                  Date Filter
                </label>

                <select
                  value={filterType}
                  onChange={(e) =>
                    onFilterTypeChange?.(e.target.value)
                  }
                  className="w-full border rounded-lg px-3 py-2"
                >
                    {showUserFilter && (
                  <option value="">
                    All Data
                  </option>
                    )}
                  <option value="today">
                    Today
                  </option>

                  <option value="week">
                    This Week
                  </option>

                  <option value="month">
                    This Month
                  </option>

                  <option value="year">
                    This Year
                  </option>

                  <option value="fiscal">
                    Fiscal Year
                  </option>
                  <option value="custom">
                   Custom Range
                  </option>
                </select>
              </div>

            <div className="space-y-4">

            <div>
                <label className="block text-sm font-medium mb-2">
                From Date
                </label>

                <input
                type="date"
                value={dateRange.from}
                onChange={(e) => {
                onDateRangeChange?.({
                    ...dateRange,
                    from: e.target.value,
                });

                onFilterTypeChange?.("custom");
                }}
                className="w-full border rounded-lg px-3 py-2"
                />
            </div>

            <div>
                <label className="block text-sm font-medium mb-2">
                To Date
                </label>

                <input
                type="date"
                value={dateRange.to}
                onChange={(e) => {
                onDateRangeChange?.({
                    ...dateRange,
                    to: e.target.value,
                });

                onFilterTypeChange?.("custom");
                }}
                className="w-full border rounded-lg px-3 py-2"
                />
            </div>

            </div>
            </>
          )}

        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t p-5">
          <div className="flex gap-3">

            <button
             onClick={() => {
                onReset?.();
                }}
              className="flex-1 border rounded-lg py-2.5 hover:bg-gray-50"
            >
              Reset
            </button>

            <button
              onClick={() => {
                onApply?.();
                onClose?.();
              }}
              className="flex-1 bg-red-600 text-white rounded-lg py-2.5 hover:bg-red-700"
            >
              Apply
            </button>

          </div>
        </div>

      </div>
    </>
  );
};

export default FilterDrawer;